// import { useEffect, useState } from 'react'
// import { Link, useParams, useNavigate } from 'react-router-dom'
// import { useDispatch, useSelector } from 'react-redux'
// import { PatternFormat } from 'react-number-format';

// import Spinner from '../Layout/Spinner'
// import NotAuthorized from '../Others/NotAuthorized';

// import { getContract, updateContract } from "../../features/contractSlice"
// import { formatAddress, determineAccess } from '../../utils/Helper';

// const EditContractInfo = () => {
//     let access = false;

//     const navigate = useNavigate()
//     const dispatch = useDispatch()
//     const { id } = useParams()

//     const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
//     const { contract, subscriptions, agentInfo, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

//     const [formData, setFormData] = useState({})

//     useEffect(() => {
//         const contract_id = id
//         dispatch(getContract({ contract_id, idToken }))
//         setFormData(contract)
//     }, [])

//     const handleFormData = input => e => {
//         const { value } = e.target

//         setFormData(prevState => ({
//             ...prevState,
//             [input]: value
//         }))
//     }

//     const submitFormData = (e) => {
//         e.preventDefault()

//         const data = { ...formData }
//         dispatch(updateContract({ data, idToken }))
//             .unwrap()
//             .then(() => {
//                 navigate(`/contract-details/${data.contract_id}`);
//             })
//             .catch((error) => {
//                 console.error('Error updating contract:', error);
//             });
//     }

//     access = determineAccess(role, email, agentEmail, contract)

//     if (!access) return <NotAuthorized />

//     if (loading) return <Spinner />

//     return (
//         <div className='min-h-screen'>
//             <div className="container-xl lg:container m-auto px-4 py-6">
//                 <div className='text-2xl text-center font-semibold mb-6 uppercase'>Edit Contract</div>
//                 <div className='font-bold text-xl mb-5'>Address - {formatAddress(formData.address, formData.apartment, formData.city, formData.state, formData.zipcode)}</div>

//                 <form onSubmit={submitFormData}>
//                     <div>
//                         {(role === "Agent" || role === "Transaction Coordinator") && (
//                             <div>
//                                 <div className="flex items-center justify-between gap-4">
//                                     <div className='font-semibold text-xl'>Sales Price</div>
//                                     <div className="relative flex-1">
//                                         <span className="absolute left-3 top-1/2 transform -translate-y-1/2">$</span>
//                                         <input
//                                             className='block w-full px-4 py-2 pl-6 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="sale_price"
//                                             defaultValue={formData.sale_price}
//                                             type="number"
//                                             onChange={handleFormData("sale_price")}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div>
//                                     <div className='font-semibold text-xl mt-5'>Buyer</div>
//                                     <div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="buyer_name"
//                                                 defaultValue={formData.buyer_name}
//                                                 placeholder="Name"
//                                                 type="text"
//                                                 onChange={handleFormData("buyer_name")}
//                                             />
//                                         </div>

//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="buyer_email"
//                                                 defaultValue={formData.buyer_email}
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 onChange={handleFormData("buyer_email")}
//                                             />
//                                         </div>
//                                         <div className='mb-2'>
//                                             <PatternFormat
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 format="(###) ### ####"
//                                                 mask="_"
//                                                 name="buyer_phone"
//                                                 value={formData.buyer_phone}
//                                                 placeholder="Mobile Phone"
//                                                 type="text"
//                                                 onChange={handleFormData("buyer_phone")}
//                                             >
//                                             </PatternFormat>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <div className='font-semibold text-xl mt-5'>Co-Buyer</div>
//                                     <div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="co_buyer_name"
//                                                 defaultValue={formData.co_buyer_name}
//                                                 placeholder="Name"
//                                                 type="text"
//                                                 onChange={handleFormData("co_buyer_name")}
//                                             />
//                                         </div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="co_buyer_email"
//                                                 defaultValue={formData.co_buyer_email}
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 onChange={handleFormData("co_buyer_email")}
//                                             />
//                                         </div>

//                                         <div className='mb-2'>
//                                             <PatternFormat
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 format="(###) ### ####"
//                                                 mask="_"
//                                                 name="co_buyer_phone"
//                                                 value={formData.co_buyer_phone}
//                                                 placeholder="Mobile Phone"
//                                                 type="text"
//                                                 onChange={handleFormData("co_buyer_phone")}
//                                             >
//                                             </PatternFormat>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <div className='font-semibold text-xl mt-5'>Seller</div>
//                                     <div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="seller_name"
//                                                 defaultValue={formData.seller_name}
//                                                 placeholder="Name"
//                                                 type="text"
//                                                 onChange={handleFormData("seller_name")}
//                                             />
//                                         </div>

//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="seller_email"
//                                                 defaultValue={formData.seller_email}
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 onChange={handleFormData("seller_email")}
//                                             />
//                                         </div>
//                                         <div className='mb-2'>
//                                             <PatternFormat
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 format="(###) ### ####"
//                                                 mask="_"
//                                                 name="seller_phone"
//                                                 value={formData.seller_phone}
//                                                 placeholder="Mobile Phone"
//                                                 type="text"
//                                                 onChange={handleFormData("seller_phone")}
//                                             >
//                                             </PatternFormat>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div>
//                                     <div className='font-semibold text-xl mt-5'>Co-Seller</div>
//                                     <div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="co_seller_name"
//                                                 defaultValue={formData.co_seller_name}
//                                                 placeholder="Name"
//                                                 type="text"
//                                                 onChange={handleFormData("co_seller_name")}
//                                             />
//                                         </div>
//                                         <div className='mb-2'>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="co_seller_email"
//                                                 defaultValue={formData.co_seller_email}
//                                                 placeholder="Email"
//                                                 type="email"
//                                                 onChange={handleFormData("co_seller_email")}
//                                             />
//                                         </div>

//                                         <div className='mb-2'>
//                                             <PatternFormat
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 format="(###) ### ####"
//                                                 mask="_"
//                                                 name="co_seller_phone"
//                                                 value={formData.co_seller_phone}
//                                                 placeholder="Mobile Phone"
//                                                 type="text"
//                                                 onChange={handleFormData("co_seller_phone")}
//                                             >
//                                             </PatternFormat>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}

//                         <div>
//                             <div className='font-semibold text-xl mt-5'>Loan Officer</div>
//                             <div>
//                                 <div className='mb-2'>
//                                     <input
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         name="loan_officer"
//                                         defaultValue={formData.loan_officer}
//                                         placeholder="Name"
//                                         type="text"
//                                         onChange={handleFormData("loan_officer")}
//                                     />
//                                 </div>

//                                 <div className='mb-2'>
//                                     <input
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         name="loan_officer_email"
//                                         defaultValue={formData.loan_officer_email}
//                                         placeholder="Email"
//                                         type="email"
//                                         onChange={handleFormData("loan_officer_email")}
//                                     />
//                                 </div>
//                                 <div className='mb-2'>
//                                     <PatternFormat
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         format="(###) ### ####"
//                                         mask="_"
//                                         name="loan_officer_phone"
//                                         // defaultValue={loan_officer_phone}
//                                         value={formData.loan_officer_phone}
//                                         placeholder="Mobile Phone"
//                                         type="text"
//                                         onChange={handleFormData("loan_officer_phone")}
//                                     >
//                                     </PatternFormat>
//                                 </div>
//                             </div>
//                         </div>

//                         <div>
//                             <div className='font-semibold text-xl mt-5'>Title Company</div>
//                             <div>
//                                 <div className='mb-2'>
//                                     <input
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         name="title_company"
//                                         defaultValue={formData.title_company}
//                                         placeholder="Name"
//                                         type="text"
//                                         onChange={handleFormData("title_company")}
//                                     />
//                                 </div>

//                                 <div className='mb-2'>
//                                     <input
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         name="title_company_email"
//                                         defaultValue={formData.title_company_email}
//                                         placeholder="Email"
//                                         type="email"
//                                         onChange={handleFormData("title_company_email")}
//                                     />
//                                 </div>
//                                 <div className='mb-2'>
//                                     <PatternFormat
//                                         className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                         format="(###) ### ####"
//                                         mask="_"
//                                         name="title_company_phone"
//                                         value={formData.title_company_phone}
//                                         placeholder="Mobile Phone"
//                                         type="text"
//                                         onChange={handleFormData("title_company_phone")}
//                                     >
//                                     </PatternFormat>
//                                 </div>
//                             </div>
//                         </div>

//                     </div>

//                     <div className='flex justify-between mt-5'>
//                         <button
//                             className='uppercase h-[36px] bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-center text-sm'>
//                             <Link to="/">Dashboard</Link>

//                         </button>
//                         <button
//                             className='uppercase h-[36px] bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-center text-sm'
//                             type="submit">
//                             save contract
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     )
// }

// export default EditContractInfo

import { useEffect, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { PatternFormat } from 'react-number-format';

import Spinner from '../Layout/Spinner'
import NotAuthorized from '../Others/NotAuthorized';

import { getContract, updateContract } from "../../features/contractSlice"
import { formatAddress, determineAccess } from '../../utils/Helper';

const EditContractInfo = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()

    const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
    const { contract, loading, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

    const [formData, setFormData] = useState({})

    useEffect(() => {
        const contract_id = id
        dispatch(getContract({ contract_id, idToken }))
    }, [dispatch, id, idToken])

    useEffect(() => {
        if (contract && Object.keys(contract).length > 0) {
            setFormData(contract)
        }
    }, [contract])

    const handleFormData = input => e => {
        const { value } = e.target
        setFormData(prevState => ({
            ...prevState,
            [input]: value
        }))
    }

    const submitFormData = (e) => {
        e.preventDefault()
        dispatch(updateContract({ data: formData, idToken }))
            .unwrap()
            .then(() => {
                navigate(`/contract-details/${formData.contract_id}`);
            })
            .catch((error) => {
                console.error('Error updating contract:', error);
            });
    }

    const access = determineAccess(role, email, agentEmail, contract)
    if (!access) return <NotAuthorized />
    if (loading) return <Spinner />

    return (
        <div className="bg-gray-50 min-h-screen py-8">
            <div className="max-w-4xl mx-auto px-4">
                <div className="mb-8 flex items-center justify-between">
                    <Link
                        to={`/contract-details/${id}`}
                        className="inline-flex items-center text-gray-600 hover:text-gray-900"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                        </svg>
                        Back to Contract Details
                    </Link>
                </div>

                <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-8">
                    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                        <h1 className="text-xl font-bold text-white">Edit Contract Details</h1>
                    </div>

                    <div className="p-6">
                        <div className="flex items-center mb-6">
                            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-semibold text-gray-800">
                                {formData.address && formatAddress(formData.address, formData.apartment, formData.city, formData.state, formData.zipcode)}
                            </h2>
                        </div>

                        <form onSubmit={submitFormData}>
                            {(role === "Agent" || role === "Transaction Coordinator") && (
                                <>
                                    {/* Buyer Information */}
                                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                        <div className="flex items-center mb-4">
                                            <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-lg font-semibold text-gray-800">Buyer Information</h2>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="buyer_name"
                                                    value={formData.buyer_name || ''}
                                                    placeholder="Enter full name"
                                                    type="text"
                                                    onChange={handleFormData("buyer_name")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="buyer_email"
                                                    value={formData.buyer_email || ''}
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={handleFormData("buyer_email")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <PatternFormat
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    format="(###) ### ####"
                                                    mask="_"
                                                    name="buyer_phone"
                                                    value={formData.buyer_phone || ''}
                                                    placeholder="Enter phone number"
                                                    type="text"
                                                    onChange={handleFormData("buyer_phone")}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Co-Buyer Information */}
                                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                        <div className="flex items-center mb-4">
                                            <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-lg font-semibold text-gray-800">Co-Buyer Information</h2>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="co_buyer_name"
                                                    value={formData.co_buyer_name || ''}
                                                    placeholder="Enter full name"
                                                    type="text"
                                                    onChange={handleFormData("co_buyer_name")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="co_buyer_email"
                                                    value={formData.co_buyer_email || ''}
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={handleFormData("co_buyer_email")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <PatternFormat
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    format="(###) ### ####"
                                                    mask="_"
                                                    name="co_buyer_phone"
                                                    value={formData.co_buyer_phone || ''}
                                                    placeholder="Enter phone number"
                                                    type="text"
                                                    onChange={handleFormData("co_buyer_phone")}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Seller Information */}
                                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                        <div className="flex items-center mb-4">
                                            <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mr-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-lg font-semibold text-gray-800">Seller Information</h2>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="seller_name"
                                                    value={formData.seller_name || ''}
                                                    placeholder="Enter full name"
                                                    type="text"
                                                    onChange={handleFormData("seller_name")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="seller_email"
                                                    value={formData.seller_email || ''}
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={handleFormData("seller_email")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <PatternFormat
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    format="(###) ### ####"
                                                    mask="_"
                                                    name="seller_phone"
                                                    value={formData.seller_phone || ''}
                                                    placeholder="Enter phone number"
                                                    type="text"
                                                    onChange={handleFormData("seller_phone")}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Co-Seller Information */}
                                    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                        <div className="flex items-center mb-4">
                                            <div className="h-8 w-8 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 mr-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                                                </svg>
                                            </div>
                                            <h2 className="text-lg font-semibold text-gray-800">Co-Seller Information</h2>
                                        </div>

                                        <div className="space-y-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="co_seller_name"
                                                    value={formData.co_seller_name || ''}
                                                    placeholder="Enter full name"
                                                    type="text"
                                                    onChange={handleFormData("co_seller_name")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                                <input
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    name="co_seller_email"
                                                    value={formData.co_seller_email || ''}
                                                    placeholder="Enter email address"
                                                    type="email"
                                                    onChange={handleFormData("co_seller_email")}
                                                />
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                                <PatternFormat
                                                    className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                                    format="(###) ### ####"
                                                    mask="_"
                                                    name="co_seller_phone"
                                                    value={formData.co_seller_phone || ''}
                                                    placeholder="Enter phone number"
                                                    type="text"
                                                    onChange={handleFormData("co_seller_phone")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Loan Officer Information */}
                            <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                <div className="flex items-center mb-4">
                                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                    <h2 className="text-lg font-semibold text-gray-800">Loan Officer Information</h2>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                        <input
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            name="loan_officer"
                                            value={formData.loan_officer || ''}
                                            placeholder="Full Name"
                                            type="text"
                                            onChange={handleFormData("loan_officer")}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                        <input
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            name="loan_officer_email"
                                            value={formData.loan_officer_email || ''}
                                            placeholder="Email Address"
                                            type="email"
                                            onChange={handleFormData("loan_officer_email")}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                        <PatternFormat
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            format="(###) ### ####"
                                            mask="_"
                                            name="loan_officer_phone"
                                            value={formData.loan_officer_phone || ''}
                                            placeholder="Phone Number"
                                            type="text"
                                            onChange={handleFormData("loan_officer_phone")}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Title Company Information */}
                            <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                                <div className="flex items-center mb-4">
                                    <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 mr-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                        </svg>
                                    </div>
                                    <h2 className="text-lg font-semibold text-gray-800">Title Company Information</h2>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                        <input
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            name="title_company"
                                            value={formData.title_company || ''}
                                            placeholder="Enter company name"
                                            type="text"
                                            onChange={handleFormData("title_company")}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                        <input
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            name="title_company_email"
                                            value={formData.title_company_email || ''}
                                            placeholder="Email Address"
                                            type="email"
                                            onChange={handleFormData("title_company_email")}
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                        <PatternFormat
                                            className="block w-full px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                                            format="(###) ### ####"
                                            mask="_"
                                            name="title_company_phone"
                                            value={formData.title_company_phone || ''}
                                            placeholder="Phone Number"
                                            type="text"
                                            onChange={handleFormData("title_company_phone")}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mt-8 flex justify-between">
                                <Link
                                    to="/dashboard"
                                    className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                    </svg>
                                    Dashboard
                                </Link>
                                <button
                                    type="submit"
                                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                {apiError && (
                    <div className="mt-4 p-4 bg-red-50 border-l-4 border-red-400 rounded">
                        <p className="text-sm text-red-700">{apiErrorMessage}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditContractInfo;

